import React from "react";
import { motion } from "framer-motion";
import Sparkline from "@/components/Sparkline";

export default function StatCard({
  label,
  value,
  hint,
  icon: Icon,
  spark,
  color = "#1BA89F",
  delay = 0,
  testid,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, type: "spring", stiffness: 320, damping: 28 }}
      whileHover={{ y: -2 }}
      className="relative overflow-hidden rounded-[16px] glass glass-hover p-5"
      data-testid={testid}
    >
      <div
        className="absolute -right-10 -top-10 h-32 w-32 rounded-full"
        style={{ background: `radial-gradient(closest-side, ${color}33, transparent 70%)`, filter: "blur(12px)" }}
      />
      <div className="relative flex items-start justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-[color:var(--text-3)]">{label}</div>
          <div className="mt-2 font-display text-3xl font-semibold tabular-nums text-[color:var(--text-1)]" style={{ color }}>{value}</div>
          {hint ? <div className="mt-0.5 text-xs text-[color:var(--text-3)]">{hint}</div> : null}
        </div>
        {Icon ? (
          <div
            className="h-9 w-9 rounded-md flex items-center justify-center"
            style={{ background: "rgba(255,255,255,0.03)", color }}
          >
            <Icon className="h-4 w-4" />
          </div>
        ) : null}
      </div>
      {spark ? (
        <div className="mt-3 -mx-1">
          <Sparkline data={spark} color={color} height={42} />
        </div>
      ) : null}
    </motion.div>
  );
}
